import { Component, OnInit, Input, OnChanges, Output, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { NgxFfmService } from '../../ngx-ffm.service';
import { Files } from '../../models/file';
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Documents } from '../../ngx-ffm.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FindValueSubscriber } from 'rxjs/internal/operators/find';

@Component({
  selector: 'file-actions',
  templateUrl: './file-actions.component.html',
  styleUrls: ['./file-actions.component.css']
})
export class FileActionsComponent implements OnInit, OnChanges {

  @ViewChild('inputFile') inputFile: ElementRef;

  @Input() uploadFileName: string;
  @Input() fileInput: Files;

  @Output() output = new EventEmitter<any>();

  error: string;
  errorMessage = '';
  load = false;
  file: Files;
  base64;
  base64Data;
  arrDocuments = [];
  arrDocumentsCopy = [];
  openableExtensions = ['txt', 'py', 'png', 'jpg', 'jpeg', 'gif', 'md', 'css', 'pdf', 'json'];
  arrSelectedDocuments = [];
  uploadResponse = { status: '', message: '', filePath: '' };
  hasInput = false;
  arrAllowedExtensions = ['jpg', 'JPG', 'png', 'PNG', 'jpeg', 'JPEG', 'svg', 'SVG', 'tif'];

  arrSelectedImages = [];
  arrSelectedPDF = [];



  constructor(
    public ngxFfmService: NgxFfmService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar) {

  }


  ngOnInit(): void {
    /* if (this.fileInput) {
      this.file = new Files(this.fileInput);
      this.arrSelectedDocuments = this.file.arrSelected;
      this.loadDocuments(this.fileInput.filePath);
      this.hasInput = true;
    } else {
      this.hasInput = false;
    } */

  }


  ngOnChanges(): void {
    if (this.fileInput) {
      this.file = new Files(this.fileInput);
      this.arrSelectedDocuments = this.file.arrSelected;
      if (this.file.arrSelected.length === 0) {
        this.load = true;
        this.loadDocuments(this.file.filePath);
      }
      this.hasInput = true;
    } else {
      this.hasInput = false;
    }
  }


  /**
   * Download selected documents. (File.arrSelected)
   */
  async btnDownloadDocument_Click() {
    if (this.arrSelectedDocuments.length !== 0) {
      this.load = true;
      this.errorMessage = '';
      this.base64 = undefined;
      let count = 0;
      this.arrSelectedDocuments.forEach(async (selectedDoc, index) => {
        await this.ngxFfmService.getDocumentOpen(selectedDoc, this.file.filePath).then(async data => {
          count++;
          this.load = true;
          this.base64 = 'data:' + data['mimetype'] + ';charset=utf-8;base64,';
          this.base64 += data['data'];

          const downlink = document.createElement('a');


          if (this.arrSelectedDocuments.length === count) {
            this.load = false;
            this.arrSelectedDocuments = [];

          }

          downlink.href = this.base64;
          downlink.download = selectedDoc;
          downlink.click();
          this.arrDocuments.map(docs => {
            docs.select = false;
          });
        });
      }, error => {
        this.openSnackBar('Something went wrong!', 'OK');
      });
    } else {
      this.load = false;
      this.errorMessage = 'No file selected!';
    }

  }


  /**
   * Delete selected documents. (File.arrSelected)
   */
  btnDeleteDoc_Click() {
    if (this.arrSelectedDocuments.length !== 0) {

      this.errorMessage = '';
      const title = 'Warning!';
      const message = 'Delete selected document(s)?';
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        panelClass: 'myapp-no-padding-dialog',
        height: '30vh',
        width: '35vw',
        minWidth: '300px',
        data: {
          message,
          title
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          const currentDir = this.fileInput.filePath.split('/');
          this.load = true;
          this.ngxFfmService.deleteDocument(this.arrSelectedDocuments, this.file.filePath).subscribe(data => {
            this.load = false;
            result = {
              type: 'delete',
              value: {
                item_number: currentDir[currentDir.length - 1],
                data: this.arrSelectedDocuments
              }
            };
            this.output.emit(result);
            this.arrSelectedDocuments = [];
          }, error => {
            this.load = false;
            this.openSnackBar('Something went wrong!', 'OK');
          });
          setTimeout(async () => {
            await this.loadDocuments(this.fileInput.filePath);
          }, 1500);
        }
      });
    } else {
      this.errorMessage = 'No file selected!';
    }
  }


  /**
   * Gets the file data and calls upload and preview.
   * @param event Upload data.
   */
  async onFileChange(event) {
    this.arrSelectedImages = [];
    this.arrSelectedPDF = [];
    if (event.target.files) {
      this.errorMessage = `${event.target.files.length} file selected.`;
      setTimeout(() => {
        this.errorMessage = '';
      }, 2000);
      if (event.target.files.length > 0 && event.target.files.length !== 1) {
        for (let i = 0; i < event.target.files.length; i++) {
          const ext = (event.target.files[i].name).split('.');
          if (this.arrAllowedExtensions.includes(ext[ext.length - 1])) {
            this.arrSelectedImages.push(event.target.files[i]);
          } else {

            if (event.target.files[i].type === 'application/pdf') {
              this.arrSelectedPDF.push(event.target.files[i]);
            }
          }
        }

        if (this.arrSelectedImages.length !== 0) {
          this.createPreview(this.arrSelectedImages);
          this.uploadFile(this.arrSelectedImages);
        }
        if (this.arrSelectedPDF.length !== 0) {
          this.arrSelectedPDF = this.uploadPDF(this.arrSelectedPDF);
          this.output.emit({ type: 'insert', value: this.arrSelectedPDF });
          // this.uploadFile(this.arrSelectedPDF);
        }

        if (this.arrSelectedImages.length === 0 && this.arrSelectedPDF.length === 0) {
          this.openSnackBar('Not correct extensions!', 'OK');
        }

      } else {
        if (event.target.files.length === 1) {
          const ext = (event.target.files[0].name).split('.');
          if (this.arrAllowedExtensions.includes(ext[ext.length - 1])) {
            this.arrSelectedImages.push(event.target.files[0]);
            this.uploadFile(this.arrSelectedImages);
            this.createPreview(this.arrSelectedImages);
          } else {
            if (event.target.files[0].type === 'application/pdf') {
              this.arrSelectedPDF.push(event.target.files[0]);
              this.arrSelectedPDF = this.uploadPDF(this.arrSelectedPDF);
              this.output.emit({ type: 'insert', value: this.arrSelectedPDF });
              //   this.uploadFile(this.arrSelectedPDF);
            }
          }


        }
      }

    } else {
      this.openSnackBar('No file selected!', 'OK');
    }
  }

  uploadPDF(files) {
    for (let i = 0; i < files.length; i++) {
      const name = files[i].name
        .replace(/[ÀÁÂÃÄÅ]/g, 'A')
        .replace(/[àáâãäå]/g, 'a')
        .replace(/[ÈÉÊË]/g, 'E')
        .replace(/[é]/g, 'e')
        .replace(/[ő]/g, 'o')
        .replace(/[Ő]/g, 'O')
        .replace(/[ú]/g, 'u')
        .replace(/[Ú]/g, 'U')
        .replace(/[Ó]/g, 'O')
        .replace(/[ó]/g, 'o')
        .replace(/[ü]/g, 'u')
        .replace(/[Ü]/g, 'U')
        .replace(/[ö]/g, 'o')
        .replace(/[Ö]/g, 'O')
        .replace(/[í]/g, 'i')
        .replace(/[Í]/g, 'I');
      files[i] = new File([files[i]], name, { type: files[i].type });

      const fileToLoad = files[i];
      const fileReader = new FileReader();
      fileReader.onload = function (fileLoadedEvent) {
        files[i].base64 = fileLoadedEvent.target.result;
      };
      fileReader.readAsDataURL(fileToLoad);
    }
    return files;
  }


  async createPreview(array) {

    if (array.length === 1) {
      const filetype = array[0].type;
      if (filetype === 'image/tiff') {
        const formData = new FormData();
        formData.append('file', array[0], array[0].name);

        this.ngxFfmService.convertDocument(formData).then(base64result => {
          const result = this.b64toBlob(base64result.data, 'image/png');
          array[0].filename = base64result.name;
          this.imgLoad(array, result);
        });

      } else {
        this.imgLoad(array);
      }
    } else {
      this.imgLoad(array);
    }
  }


  imgLoad(array, result?) {
    let resultObj;

    for (let i = 0; i < array.length; i++) {

      /******************************/
      const type = array[i].type;

      const reader = new FileReader();
      if (type === 'image/tiff') {
        reader.readAsDataURL(result);
      } else {
        reader.readAsDataURL(array[i]);
      }

      reader.onload = e => {
        const img = new Image();
        img.src = e.target.result.toString();
        img.onload = () => {
          const data = document.createElement('canvas');
          const w = img.width;
          const h = img.height;
          const a = w / h;
          const width = h > w ? 500 : 500 * a;
          const height = h > w ? 500 / a : 500;

          data.width = width;
          data.height = height;
          const ctx = data.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          ctx.canvas.toBlob((blob) => {
            const readerFile = new FileReader();
            readerFile.readAsDataURL(blob);
            readerFile.onloadend = (e) => {
              this.base64Data = readerFile.result;
              array[i].base64 = this.base64Data;
              if (i === array.length - 1) {
                if (array.length !== 1 && array.length > 0) {
                  resultObj = {
                    type: 'insert',
                    value: {
                      data: array,
                    }
                  };
                } else {
                  if (type === 'image/tiff') {

                    const tmp = array[i].name.split('.');
                    const ext = tmp[tmp.length - 1];
                    const name = this.uploadFileName ? this.uploadFileName + `.${ext}` : array[i].name;

                    resultObj = {
                      type: 'insert',
                      value: {
                        name,
                        data: this.base64Data
                      }
                    };
                  } else {

                    const tmp = array[i].name.split('.');
                    const ext = tmp[tmp.length - 1];
                    const name = this.uploadFileName ? this.uploadFileName + `.${ext}` : array[i].name;

                    resultObj = {
                      type: 'insert',
                      value: {
                        name,
                        data: this.base64Data
                      }
                    };
                  }

                }
                this.output.emit(resultObj);
              }
            };
          }, type, 1);
        };
      };
    }
  }


  /**
   * Loads the content of the given directory.
   * @param filePath Path.
   */
  async loadDocuments(filePath) {
    await this.ngxFfmService.getDocuments(filePath).then(async data => {
      if (data.length === 0) {
        this.load = false;
        this.arrDocuments = [];
        //this.openSnackBar('No directory exist or the directory is empty', 'OK');
      } else {
        this.arrDocumentsCopy = [];
        this.arrDocuments = [];
        this.arrDocumentsCopy = data;
        this.arrDocumentsCopy.forEach(element => {
          const docObj: Documents = {};
          let filteredDoc = [];
          const asd: string[] = element.replace(/ /g, ',').split(',');
          filteredDoc = asd.filter(doc => {
            return doc !== '';
          });
          filteredDoc.forEach((docdata, index) => {
            if (index === 2) {
              docObj.owner = docdata;
            } else if (index === 3) {
              docObj.group = docdata;
            } else if (index === 4) {
              docObj.size = docdata;
            } else if (index === 5) {
              docObj.mt = filteredDoc[index] + ' ' + filteredDoc[index + 1] + ' ' + filteredDoc[index + 2];
            } else if (index === 8) {
              if (filteredDoc[index + 1] === undefined) {
                docObj.filename = docdata;
              } else {
                docObj.filename = docdata + ' ' + filteredDoc[index + 1];
              }
            }
            if (index === filteredDoc.length - 1) {
              if (!filteredDoc[0].includes('d')) {
                this.arrDocuments.push(docObj);
              }
            }
          });
        });

        this.arrDocuments.map(doc => {
          const splitList = doc.filename.split('.');
          const extension = splitList[splitList.length - 1];
          if (this.openableExtensions.includes(extension)) {
            doc.canOpen = true;
          } else {
            doc.canOpen = false;
          }
          if (parseInt(doc.size) < 10000000) {
            doc.large = false;
          } else {
            doc.large = true;
          }
          doc.select = false;
        });
        this.load = false;
      }

    });
    const result = {
      type: 'select',
      value: this.arrDocuments
    };
    this.output.emit(result);
    return this.arrDocuments;
  }

  /**
   * Calls backend post document function.
   * @param array File array.
   */
  uploadFile(array) {
    this.errorMessage = '';
    this.load = false;
    const formData = new FormData();



    array.forEach(data => {

      const ext = data.name.split('.')[1];
      const n = this.uploadFileName ? this.uploadFileName + `.${ext}` : data.name;

      formData.append('file', data, n);
    });

    this.ngxFfmService.postDocument(formData, this.file.filePath).subscribe(
      (res) => {

        if (res.msg) {
          this.loadDocuments(this.fileInput.filePath);
          this.inputFile.nativeElement.value = '';
          this.load = false;
        } else {
          this.uploadResponse = res;
          if (parseInt(this.uploadResponse.message) === 100) {
            this.load = true;
            this.uploadResponse.status = undefined;
          }
        }
      },
      (err) => { this.error = err; this.openSnackBar('Something went wrong!', 'OK'); }
    );

  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 4000,
      panelClass: ['blue-snackbar']
    });
  }

  openDocument(row) {
    this.base64 = undefined;
    this.ngxFfmService.getDocumentOpen(row.filename, this.file.filePath).then(async data => {
      const extension: string = row.filename.split('.');
      if (extension[extension.length - 1] === 'md') {
        this.base64 = 'data:text/markdown;charset=utf-8;base64,';
      } else {
        this.base64 = 'data:' + data['mimetype'] + ';charset=utf-8;base64,';
      }
      this.base64 += data['data'];
      const Window = window.open(row.filename);
      Window.document.write("<iframe height='100%' width='100%' src='" + this.base64 + "'></iframe");
    });
    this.errorMessage = '';
  }

  b64toBlob(dataURI, type) {

    var byteString = atob(dataURI.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);

    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type });
  }

}
